import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Tabs
} from "../../ui/ot";
import { useTranslation } from "react-i18next";
import { Book, Calendar } from "lucide-react"
import BorrowedBooks from "./borrowed_books";
import CurrentlyReserved from "./currently_reserved";
import BookReviews from "./book_reviews";
import { Star } from "lucide-react"
import { useSearchParams } from "react-router-dom";

const PersonalStudy = ({
    keyPrefix = "library.personal_study",
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [searchParams, setSearchParams] = useSearchParams();
    const mode = searchParams.get('mode');
    const [activeKey, setActiveKey] = useState(mode || "borrowed")
    return (<Row gutter={[32, 32]}>
        <Col span={24} className="py-6  bg-[#f9f5f0]">
            <Row>
                <Col span={24}>
                    <Row>
                        <Col span={24}>
                            <Typography.Title level={2} className="text-3xl font-bold tracking-tight text-[#e8a05c]">{t('')}</Typography.Title>
                        </Col>
                        <Col span={24}>
                            <Typography.P className="text-muted-foreground">{t('manage_loans_and_reservations')}</Typography.P>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Tabs
                        onChange={(value) => { setActiveKey(value) }}
                        defaultActiveKey={activeKey}
                        activeKey={activeKey}
                        items={[
                            {
                                key: "borrowed",
                                tab: <> <Book className="mr-2 h-4 w-4" />
                                    {t('currently_borrowed')} </>
                            },
                            {
                                key: "reserved",
                                tab: <>  <Calendar className="mr-2 h-4 w-4" />
                                    {t('currently_reserved')} </>
                            },
                            {
                                key: "reviews",
                                tab: <>  <Star className="mr-2 h-4 w-4" />
                                    {t('book_reviews')} </>
                            },
                        ]}
                    />
                </Col>
                {activeKey === "borrowed" && <Col span={24}>
                    <BorrowedBooks />
                </Col>}
                {activeKey === "reserved" && <Col span={24}>
                    <CurrentlyReserved />
                </Col>}
                {activeKey === "reviews" && <Col span={24}>
                    <BookReviews />
                </Col>}
            </Row>
        </Col>

    </Row>)
}
export default PersonalStudy

